import ApplyNowLandingPage from 'features/payOverTime/screens/application/ApplyNowLandingPage/ApplyNowLandingPage';

export default function Page() {
  return <ApplyNowLandingPage />;
}
